import { render, staticRenderFns } from "./SingleGiftGroupCode.vue?vue&type=template&id=5f13c3e7&"
import script from "./SingleGiftGroupCode.vue?vue&type=script&lang=js&"
export * from "./SingleGiftGroupCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports